import React, { Component } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Link, Redirect } from 'react-router-dom';
// import * as firebase from 'firebase';
import AuthActions from './store/actions/authActions';
import ErrorActions from './store/actions/errorActions';
import AuthMiddleware from './store/middleware/authMiddleware';
import SignIn from './container/SignIn/signin';
import ManualSignIn from './container/ManualSignIn/manualsignin';
// import SignUp from './container/SignUp/signup';
// import SignBtn from './container/SignBtn/signbtn';
import Home from './container/Home/home';
import CourseHome from './container/CourseHome/coursehome';
import QuizTaker from './container/QuizTaker/quiztaker';
import AdditionalFields from './container/AdditionalFields/additionalfields';
import QuizStart from './container/QuizStart/quizstart';
import ShowResult from './container/ShowResult/showresult';
import { Offline, Detector } from "react-detect-offline";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Images from "./config/images";
import Snackbar from '@material-ui/core/Snackbar';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { connect } from 'react-redux';
// import history from './History'
import RouteActions from './store/actions/routeActions';
import Appbar from './container/Appbar/Appbar';
// import { withRouter } from 'react-router-dom';

function PrivateRoute({ component: Component, isAuthenticated, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => isAuthenticated === true
        ? <Component {...props} />
        : <Redirect to={{ pathname: '/', state: { from: props.location } }} />}
    />
  )
}

function PrivateRoute2({ component: Component, isAuthenticated, isProctoringKeyVerified, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => (isAuthenticated && isProctoringKeyVerified) === true
        ? <Component {...props} />
        : <Redirect to={{ pathname: `/course/${sessionStorage.getItem('courseName')}`, state: { from: props.location } }} />}
    />
  )
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logoutPopup: false,
      logoutPopupOpen: false,
      anchorEl: null,
      isAuthenticated: false,
      isProctoringKeyVerified: false,
      currentPath: "",
      confirmPopup: false
    };

    // window.onbeforeunload = () => {
    //   window.FB.getLoginStatus((res) => {
    //     res.authResponse.accessToken = null
    //   })
    //   return null;
    // };
  }


  componentWillReceiveProps(nextprops) {
    if (nextprops.user) {
      sessionStorage.setItem('sessionStorageUser',JSON.stringify(nextprops.user))
      this.setState({
        isAuthenticated: true
      })
      sessionStorage.setItem("panaCloudId", nextprops.user.panacloudid)
      sessionStorage.setItem("token", nextprops.user.pc_access_token)
    }
    else if (sessionStorage.getItem('sessionStorageUser')){
        this.setState({
          isAuthenticated: true
        })
    }
    else {
      this.setState({ isAuthenticated: false })
    }
    if (nextprops.verifyProctoringKey === "Success") {
      sessionStorage.setItem("proctoringKey", nextprops.verifyProctoringKey)

      this.setState({
        isProctoringKeyVerified: true
      })
    }
    else {
      this.setState({ isProctoringKeyVerified: false })
    }
  }

  componentWillMount() {
    let token = sessionStorage.getItem('token')
    let proctoringKey = sessionStorage.getItem('proctoringKey')
    if (token) {
      this.setState({
        isAuthenticated: true
      })
    }
    else {
      this.setState({ isAuthenticated: false })
    }
    if (proctoringKey === "Success") {
      this.setState({
        isProctoringKeyVerified: true
      })
    }
  }

  componentDidMount() {
    // this.props.routes(history);
    // console.log(history);
    /*
    this.props.clearstate();
    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "//connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

    window.fbAsyncInit = () => {
      window.FB.init({
        appId: 1417860348486472,
        status: true,
        cookie: true,
        xfbml: true,
        version: 'v3.0'
      });
      window.FB.getLoginStatus((res) => {
        // console.log(res)
        this.props.token(res);
      })
      window.FB.Event.subscribe('auth.statusChange');
    };
    */
  }

  handleClick = event => {
    const { currentTarget } = event;
    this.setState(state => ({
      logoutPopup: !state.logoutPopup,
      logoutPopupOpen: this.state.logoutPopupOpen ? false : true,
      anchorEl: currentTarget,
    }));
  };

  popperClose() {
    this.setState({
      logoutPopup: false
    })
  }

  goToHomePage(){
    let path = window.location.pathname
    let sessionStorageUser = sessionStorage.getItem('sessionStorageUser')

    if(path=='/quiz/start'){
      this.setState({
        showDialog:true,
        confirmPopup: true
      })
    }
    else if(sessionStorageUser && this.props.appHistory === null){
        this.setState({ isAuthenticated: false })
      }
    else{
      this.props.appHistory.push(`/home/${sessionStorage.getItem('panaCloudId')}`)    
    }
  }

  connectionLost() {
    let path = window.location.pathname
    this.setState({
      currentPath: path,
    })
  }

  handleClose = () => {
    this.setState({ confirmPopup: false,showDialog:false });
  };

  handleCloseYes = () => {
    this.setState({ confirmPopup: false,showDialog:false });
    let sessionStorageUser = sessionStorage.getItem('sessionStorageUser')
    if(sessionStorageUser && this.props.appHistory === null){
      this.setState({ isAuthenticated: false })
    }
    else{
      this.props.appHistory.push(`/home/${sessionStorage.getItem('panaCloudId')}`)
    }
  };
  
  render() {
    const { anchorEl, logoutPopup } = this.state;
    var user = JSON.parse(sessionStorage.getItem('sessionStorageUser'))
    return (
      <Router>
        <div className="App">
          {/* <Appbar /> */}
          {!this.props.onSlashRoute && <div>
            <AppBar style={{ backgroundColor: "#333333", borderBottom: "3px solid #13a89e" }}>
              <Toolbar style={{ justifyContent: "space-between" }}>
                <Button onClick={() => this.goToHomePage()} style={{ color: "white", textTransform: "none", fontSize: "18px" }}>
                  K2
                </Button>
                {this.state.showDialog ?
                  <Dialog
                    open={this.state.confirmPopup}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Are you sure you want to leave this page ?
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={this.handleClose} color="primary">
                        No
                      </Button>
                      <Button onClick={this.handleCloseYes} color="primary" autoFocus>
                        Yes
                      </Button>
                    </DialogActions>
                  </Dialog>
                  :
                  ""          
                }
                {this.props.loader ? "" :
                  <div>
                    {user && user.name ?
                      <Typography style={{ color: "white" }}>
                        <Button className='nameButton' variant="contained" color="primary" onClick={this.handleClick} style={{ backgroundColor: "#333333", textTransform: "none" }}>{user && user.name}
                          {this.state.logoutPopupOpen ? <ExpandLess /> : <ExpandMore />}
                        </Button>
                        <IconButton className='menuButton' color="inherit" aria-label="Menu" onClick={this.handleClick}>
                          <MenuIcon />
                        </IconButton></Typography>
                      :
                      <Typography>
                        {/* { <Button variant="contained" color="primary" style={{height : "50px", textTransform : "none", marginRight : "10px"}}>
                        <Link to={{pathname : '/signin'}} style={{textDecoration : "none", color : "#fff"}}>
                        Sign In With Email Password
                        </Link>
                        </Button> } */}
                        {
                        /*  
                        <Button variant="contained" color="primary" style={{textTransform : "none"}} onClick={() => { this.props.fbsignin(); this.props.clearstate() }} >
                        <img src={Images.fbIcon} width="30" height="30" style={{ marginRight: "5px" }} />
                        Sign In With Facebook</Button>
                        */
                        }
                        {/* <Link to={{pathname : '/signup'}} style={{textDecoration : "none"}}><Button variant="contained" color="primary">Sign Up</Button></Link> */}
                      </Typography>
                    }
                  </div>}
                <Popper open={logoutPopup} anchorEl={anchorEl} style={{ zIndex: 1101 }} transition placement={"bottom-end"}>
                  {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={350} style={{ marginLeft: "-28%", textAlign: "center", borderRadius: "0", boxShadow: "1px 5px 25px 0px #888" }}>
                      <Paper>
                        <Button onClick={() => {this.props.logout(); /*this.props.fblogout();*/ this.popperClose(); sessionStorage.clear()}} style={{ padding: "10px 30px", cursor: "pointer" }}>LOGOUT</Button>
                      </Paper>
                    </Fade>
                  )}
                </Popper>
              </Toolbar>
            </AppBar>
          </div>
}
          <Route exact path="/" component={SignIn} />

          {/* <Route path="/signup" component={SignUp} /> */}
          
          <Route path="/signin" component={ManualSignIn} />
          <PrivateRoute isAuthenticated={this.state.isAuthenticated} path="/home/:id" component={Home} />
          <PrivateRoute isAuthenticated={this.state.isAuthenticated} path="/course/:name" component={CourseHome} />
          <PrivateRoute isAuthenticated={this.state.isAuthenticated} path="/quiz/proctor" component={QuizTaker} />
          <PrivateRoute2 isAuthenticated={this.state.isAuthenticated} isProctoringKeyVerified={this.state.isProctoringKeyVerified} path="/quiz/additionalinfo" component={AdditionalFields} />
          <PrivateRoute2 isAuthenticated={this.state.isAuthenticated} isProctoringKeyVerified={this.state.isProctoringKeyVerified} path="/quiz/start" component={QuizStart} />
          <PrivateRoute2 isAuthenticated={this.state.isAuthenticated} isProctoringKeyVerified={this.state.isProctoringKeyVerified} path="/showResult" component={ShowResult} />

          <div>
            <Offline onChange={() => this.connectionLost()}>
              {this.state.currentPath === "/quiz/start" ?
                <Dialog
                  open={true}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      Connection Lost, Plz Wait...
                  </DialogContentText>
                  </DialogContent>
                </Dialog> :
                <Snackbar
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  open={true}
                  ContentProps={{
                    'aria-describedby': 'message-id',
                    style: { backgroundColor: "red" }
                  }}
                  message={<span id="message-id">Internet Connection has been Disconnected</span>}
                />
              }
            </Offline>
          </div>
          <Detector
            render={({ online }) => {
              return <div>
                {online ? this.props.buttonEnable() : this.props.buttonDisable()}
              </div>
            }}
          />
        </div>
      </Router>
    );
  }
}
function mapStateToProps(state) {
  // console.log(state)
  return {
    user: state.authReducer.user,
    loader: state.authReducer.isLoading,
    verifyProctoringKey: state.quizReducer.proctoringKey,
    appHistory: state.routeReducer.appHistory,
    onSlashRoute: state.SlashRouteReducer.onSlashRoute,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    clearstate: () => { dispatch(AuthActions.ClearState()) },
    buttonDisable: () => { dispatch(ErrorActions.ButtonDisable()) },
    buttonEnable: () => { dispatch(ErrorActions.ButtonEnable()) },
    token: (response) => { dispatch(AuthMiddleware.accessTokenMiddleware(response)) },
    fblogout: () => dispatch(AuthMiddleware.fblogoutMiddleware()),
    fbsignin: () => { dispatch(AuthMiddleware.fbsigninMiddleware()) },
    routes : (history) => { dispatch(RouteActions.AppRoute(history))},
    logout: () => dispatch(AuthActions.Logout())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);




// WEBPACK FOOTER //
// ./src/App.js